// fbdata.js"../assets/image/amethy

import icon1 from "../../assets/image/icon1.jpeg";
import icon2 from "../../assets/image/icon2.jpeg";
import icon3 from "../../assets/image/icon3.jpeg";
import icon4 from "../../assets/image/icon4.jpeg";
import icon5 from "../../assets/image/icon5.jpeg";
import icon6 from "../../assets/image/icon6.jpeg";


export const jyotirvaniFeatures = [
  {
    title: "प्रामाणिक वैदिक ज्योतिषीय परामर्श",
    description:
      "JyotirVani शास्त्रीय सिद्धांतों पर आधारित सटीक भविष्यवाणी करता है।",
    icon: "image/vedic.png",
    quote: "नाडीग्रन्थं च संदीक्ष्य पश्येच्च राशिलक्षणम्।",
    source: "— बृहत्पाराशर होरा",
    meaning: "कुंडली का सूक्ष्म निरीक्षण ही सटीक भविष्यवाणी की कुंजी है।",
  },
  {
    title: "व्यक्तिगत और व्यावहारिक समाधान",
    description:
      "हम सरल और प्रभावी उपाय देते हैं जो जातक की कुंडली के अनुसार होते हैं।",
    icon: "image/solution.png",
    quote: "ग्रहपीडां विनाशाय मन्त्राणां सिध्दिरुच्यते।",
    source: "— पाराशर संहिता",
  },
  {
    title: "सेवा भाव से परिपूर्ण ज्योतिषाचार्य",
    description:
      "हमारे ज्योतिषाचार्य अनुभवी हैं और हर ग्राहक को सम्मान देते हैं।",
    icon: "image/acharya.png",
  },
  {
    title: "गोपनीयता और सम्मान के साथ परामर्श",
    description:
      "आपकी जानकारी पूर्णतः गोपनीय रखी जाती है, न कोई जल्दबाज़ी, न कोई प्रलोभन।",
    icon: "image/privacy.png",
  },
  {
    title: "ऑनलाइन सुविधा",
    description:
      "WhatsApp, कॉल या Google Meet द्वारा सुविधा प्राप्त करें।",
    icon: "image/online.png",
  },
  {
    title: "शुद्ध, अभिमंत्रित रत्न सेवा",
    description:
      "आपको आपकी कुंडली अनुसार शुद्ध और अभिमंत्रित रत्न प्रदान किए जाते हैं।",
    icon: "image/gemstone.png",
    quote: "रत्नं न तु ग्रहं कार्यं दोषनाशाय निश्चितम्।",
    source: "— रत्नपराशर",
    meaning: "उचित रत्न ही ग्रहदोष निवारण में सक्षम होता है।",
  },
];


export const accordionItems = [
  {
    id: "question-1",
    title: "प्रामाणिक वैदिक ज्योतिषीय परामर्श",
    description: "JyotirVani शास्त्रीय सिद्धांतों पर आधारित सटीक भविष्यवाणी करता है।",
    icon: icon1,
    quote: "नाडीग्रन्थं च संदीक्ष्य पश्येच्च राशिलक्षणम्।",
    source: "— बृहत्पाराशर होरा",
    meaning: "कुंडली का सूक्ष्म निरीक्षण ही सटीक भविष्यवाणी की कुंजी है।",
  },
  {
    id: "question-2",
    title: "व्यक्तिगत और व्यावहारिक समाधान",
    description: "व्यक्तिगत समाधान और सरल उपाय — रत्न, दान, जाप, विशेष पूजा — सब कुंडली अनुसार।",
    icon: icon2,
    quote: "ग्रहपीडां विनाशाय मन्त्राणां सिध्दिरुच्यते।",
    source: "— पाराशर संहिता",
    meaning: "",
  },
  {
    id: "question-3",
    title: "अनुभव और सेवा भाव से परिपूर्ण ज्योतिषाचार्य",
    description: "वर्षों का अनुभव और हज़ारों कुंडलियों का विश्लेषण — विश्वास और निष्ठा के साथ सेवा।",
    icon: icon3,
    quote: "",
    source: "",
    meaning: "",
  },
  {
    id: "question-4",
    title: "गोपनीयता और सम्मान के साथ परामर्श",
    description: "आपकी जानकारी और समस्या गोपनीय रखी जाती है — बिना जल्दबाज़ी और बिना किसी प्रलोभन के।",
    icon: icon4,
    quote: "",
    source: "",
    meaning: "",
  },
  {
    id: "question-5",
    title: "सरल और सुविधाजनक ऑनलाइन सुविधा",
    description: "घर बैठे WhatsApp, कॉल, Google Meet द्वारा परामर्श और रिपोर्ट — समय पर, विश्वसनीय।",
    icon: icon5,
    quote: "",
    source: "",
    meaning: "",
  },
  {
    id: "question-6",
    title: "शुद्ध, अभिमंत्रित और कुंडली अनुसार रत्न सेवा",
    description: "आपकी कुंडली अनुसार शुद्ध, अभिमंत्रित रत्न — रत्नधारण विधि और मुहूर्त सहित।",
    icon: icon6,
    quote: "रत्नं न तु ग्रहं कार्यं दोषनाशाय निश्चितम्।",
    source: "— रत्नपराशर",
    meaning: "उचित रत्न ही ग्रहदोष निवारण में सक्षम होता है, न कि केवल नाम का पहनावा।",
  },
];


export const plans = [
  {
    label: "Basic Plan",
    value: "₹199",
    name: "Jyotish Aarambh (ज्योतिष आरम्भ)",
    features: [
      "जन्मकुंडली का संक्षिप्त विश्लेषण",
      "वर्तमान गृह स्थिति की सामान्य जानकारी",
      "महादशा -अन्तर्दशा प्रभाव का विश्लेषण",
      "कुंडली में वर्त्तमान परेशानी का उपाय",
      "किन्ही 2 प्रश्नों का उत्तर और प्रभावी समाधान",
      "Audio/Video Call पर 10-12 मिनट Astrologer से बात",
    ],
  },
  {
    label: "Standard Plan",
    value: "₹299",
    name: "ग्रह दर्शन (Grah Darshan)",
    features: [
      "कुंडली का विस्तृत अध्ययन",
      "ग्रहों की वर्तमान दशा व दिशा",
      "3 प्रमुख प्रश्नों का उत्तर",
      "उपायों की संक्षिप्त जानकारी",
      "विंशोत्तरी दशा के अनुसार आसान उपाय",
      "Whatsapp + Phone Consultation (15-20 मिनट)",
    ],
  },
  {
    label: "Premium Plan",
    value: "₹599",
    name: "दिव्य मार्गदर्शन (Divya Marg Darshan)",
    features: [
      "सम्पूर्ण जीवन विश्लेषण (Birth to Present to Future)",
      "दशा, गोचर, ग्रहयोग के प्रभाव का विश्लेषण",
      "कुंडली दोष (कालसर्प, मंगल, पितृदोष, गुरुचांडाल, विशदोष आदि) की जांच",
      "Jyotirvani Special 180+ पृष्ठ की कुंडली PDF",
      "जीवन में आ रही रूकावटों के लिए कुंडली के षोडश वर्ग कुंडली का निरीक्षण",
      "शुद्ध वैदिक उपाय, रत्न, तंत्र-मंत्र समाधान",
      "Unlimited प्रश्न उत्तर",
      "Whatsapp + Phone Consultation (20-30 मिनट)",
    ],
  },
];



// fbdata.js

export const fbServices = [
  {
    title: "🌠 शुद्ध वैदिक कुंडली विश्लेषण",
    features: [
      "जन्म स्थान, समय और स्थान पर आधारित कुंडली",
      "सकारात्मक और नकारात्मक ग्रह",
      "राजयोग, ग्रहण योग, कालसर्प दोष, पित्र दोष",
      "करियर, प्रेम, धन, स्वास्थ्य, संतान के योग",
    ],
    quote: `लाभायैव कृतं जन्म, न हि केनचिदर्थवशात्।<br />ग्रहाणां शुभदृष्टिश्चेत्तदा संपद्यते फलम्॥`,
    quoteAuthor: "",
  },
  {
    title: "🪬 भविष्य की दिशा – निर्णय का सही समय",
    features: [
      "क्या करें? क्या ना करें? शुभ समय कौन सा है?",
      "दशा, अंतर्दशा और गोचर द्वारा सटीक भविष्यवाणी",
      "सफलता, विवाह, संतान, स्वास्थ्य, धन हानि के उत्तर",
      "विदेश यात्रा, करियर ग्रोथ और ग्रह बाधाओं का समाधान",
    ],
    quote:
      "तत्र शुभाशुभा: योगा: दशा चोपदशा: फलम्।<br />स्वदशाफलसंपत्तिर्दशाफलविवेचनम्॥",
    quoteAuthor: "— जातक पारिजात",
  },
  {
    title: "🔮 रत्न, मंत्र और उपाय – आत्मा की शांति के लिए",
    features: [
      "रुष्ट ग्रहों के समाधान",
      "शक्ति देने वाले रत्न",
      "मन को स्थिर करने वाले मंत्र",
      "भाग्य को प्रसन्न करने वाले दान",
    ],
    quote: "",
    quoteAuthor: "",
  },
];

export const fbHighlights = [
  "PDF रिपोर्ट – सरल भाषा में जीवन विश्लेषण",
  "1-on-1 काउंसलिंग – अनुभवी वैदिक आचार्य से",
  "रत्न/उपाय निर्देश – कैसे करें, कब करें, क्यों करें",
  "मंत्र और पूजा विधि – शास्त्रसम्मत और प्रभावकारी",
];
